module.exports = __webpack_public_path__ + "public/images/header-slide-4.3b651d2f00aa4ae453dc9344933999b4.png";